module.exports = __webpack_public_path__ + "f70a0730803fb3b66488d13dbb6c9133.svg";